const PREFEITURA_ILHA_BELA_CODE = Number(
  process.env.REACT_APP_CD_PREFEITURA_ILHABELA ?? '28229',
);
const PREFEITURA_ILHA_BELA_DEPENDENT_CODE = Number(
  process.env.REACT_APP_CD_PREFEITURA_ILHABELA_DEP ?? '28236',
);

export function isPrefeituraIlhaBela(codigoEmpresa?: unknown): boolean {
  return [
    PREFEITURA_ILHA_BELA_CODE,
    PREFEITURA_ILHA_BELA_DEPENDENT_CODE,
  ].includes(Number(codigoEmpresa));
}
